// A user can hold a primary role plus additional roles (e.g. a teacher who
// is also a coach). Every permission check in the UI should go through this
// helper rather than comparing user.role directly, so multi-role accounts
// get access from ANY role they hold.
export function userRoles(user) {
  if (!user) return [];
  return user.all_roles || (user.role ? [user.role] : []);
}

export function hasAnyRole(user, allowedRoles) {
  const roles = userRoles(user);
  return roles.some((r) => allowedRoles.includes(r));
}
